// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mergeWithCss, modalButtonsActionStyles } from "@awc/XDL/Utilities";
import { staticListHeaderStyles } from "@insite/content-library/Widgets/StaticList/StaticListHeader";
import { FormInputWrapper } from "@insite/mobius/FormField";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

staticListHeaderStyles.container = {
    gap: 10,
    css: css`
        padding-bottom: 10px;
        & > div {
            justify-content: space-between;
            align-items: baseline;
        }
    `,
};

staticListHeaderStyles.infoGridItem = {
    width: [12, 7, 6, 7, 8],
    css: css`
        flex-direction: column;
    `,
};

staticListHeaderStyles.saveListGridItem = {
    width: [12, 2, 3, 2, 2],
    css: css`
        justify-content: flex-end;
    `,
};

staticListHeaderStyles.saveListButton = {
    variant: "secondary",
    typographyProps: {
        css: css`
            white-space: nowrap;
        `,
    },
    css: css`
        width: 100%;
    `,
};

staticListHeaderStyles.addListToCartGridItem = {
    width: [12, 3, 3, 3, 2],
};

staticListHeaderStyles.addListToCartButton = {
    css: css`
        width: 100%;
    `,
    typographyProps: {
        css: css`
            white-space: nowrap;
        `,
    },
};

staticListHeaderStyles.listNameTextField = {
    cssOverrides: {
        formField: css`
            flex-direction: column;
            gap: 10px;
            margin-top: 15px;
            > ${TypographyStyle} {
                text-align: left;
                padding: 0;
            }
            > ${FormInputWrapper} {
                width: 100%;
            }
        `,
    },
};

staticListHeaderStyles.buttonsWrapper = {
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            margin-top: 20px;
        `,
    }),
};
